import {
  LOGIN_FORM_SUBMIT,
  REGISTER_FORM_SUBMIT,
  CALCULATE_INVOICE_DUEDATE,
  REMOVE_INVOICE_ROW,
  REMOVE_INVOICE,
  WARN_INVOICE_TO_DELETE,
  REMINDER_INVOICE_DOWNLOAD_PDF,
  CANCEL_DELETE_INVOICE,
  EDIT_INVOICE,
  GET_INVOICE_BY_ID_SUCCESS,
  COPY_INVOICE,
  CANCEL_EDIT_INVOICE,
  GET_INVOICES_SUCCESS,
  GET_INVOICES_START,
  GET_SALARIES_START,
  SAVE_AND_SEND_INVOICE,
  QUANTITY_CHANGE,
  QUANTITY_PRICE_CHANGE,
  ON_INVOICE_REVIEW,
  GET_INVOICES_FAILED,
  SAVE_INVOICE_SUCCESS,
  SAVE_AND_SEND_INVOICE_SUCCESS,
  REVIEW_INVOICE_EDIT_SUCCESS,
  REVIEW_INVOICE_EDIT_SEND_SUCCESS,
  UPDATE_INVOICE_FAILED,
  SAVE_INVOICE_FAILED,
  CHECK_AUTH_INFO,
  CHECK_AUTH_INFO_SUCCESS,
  CHECK_AUTH_INFO_FAILED,
  GET_CUSTOMERS_CHART,
  GET_CUSTOMERS_CHART_SUCCESS,
  GET_CUSTOMERS_CHART_FAILED,
  GET_INVOICE_CHART,
  GET_INVOICE_CHART_SUCCESS,
  GET_INVOICE_CHART_FAILED,
  GET_USER_TAX_INFO,
  GET_USER_TAX_INFO_SUCCESS,
  GET_COMPANY_UPDATES,
  GET_COMPANY_UPDATES_SUCCESS,
  GET_RENEW_TOKEN,
  TOKEN_VALIDATION,
  UPDATE_PROFILE,
  ON_PASSWORD_UPDATE,
  LOAD_PROFILE_SUCCESS,
  LOAD_PROFILE_FAILED,
  LOAD_PROFILE_START,
  CLOSE_PROFILE_SNACKBAR,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILED,
  CLOSE_INVOICE_REVIEW_SNACKBAR,
  COPY_INVOICE_SUCCESS,
  RESET_SCROLL_TO_SSN,
  ADD_NEW_CUSTOMER,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_FAILED,
  REMOVE_CUSTOMER,
  GET_CUSTOMER_BY_ID,
  GET_CUSTOMER_BY_ID_SUCCESS,
  SAVE_CUSTOMER_UPDATE,
  CANCEL_CUSTOMER_UPDATE,
  ADD_NEW_CUSTOMER_INVOICE,
  ADD_NEW_CUSTOMER_INVOICE_SUCCESS,
  GET_CUSTOMERS_START,
  GET_CUSTOMERS_SUCCESS,
  CUSTOMER_PAGE_CHANGE,
  INVOICE_PAGE_CHANGE,
  SAVE_INVOICE_DRAFT,
  CALCULATE_DISTANCE,
  UPDATE_INVOICEID_TO_INFO_SUCCESS,
  UPDATE_INVOICEID_TO_INFO_EXCEED_LIMIT_FAILED,
  UPDATE_INVOICEID_TO_INFO_FAILED,
  UPDATE_SELECTED_EXPENSE_IDS,
  UPDATE_SELECTED_ALLOWANCE_IDS,
  UPDATE_TAX_CARD_SUCCESS,
  UPDATE_TAX_CARD_FAILED,
  CLOSE_TAX_CARD_SNACKBAR,
  CLOSE_TAX_CARD_ERROR_SNACKBAR,
  CLOSE_TAX_CARD_SPINNER,
  GET_TAX_CARD,
  CHANGE_ADMIN_MENU,
  SEARCH_ADMIN_INVOICE,
  SEARCH_ADMIN_INVOICE_SUCCESS,
  SEARCH_ADMIN_INVOICE_FAILED,
  EXPAND_ADMIN_INVOICE,
  EXPAND_ADMIN_INVOICE_TRUE,
  EXPAND_ADMIN_INVOICE_FALSE,
  CHANGE_INVOICE_BILLING_DATE,
  SEARCH_ADMIN_USERS,
  SEARCH_ADMIN_USERS_SUCCESS,
  SEARCH_ADMIN_USERS_FAILED,
  SEARCH_ADMIN_WAGES_SUCCESS,
  SEARCH_ADMIN_WAGES_FAILED,
  GET_NEW_SALARY_START,
  GET_NEW_SALARY_SUCCESS,
  SELECT_ROW_SALARY,
  GET_SALARY_INFO,
  GET_SALARY_BY_ID_SUCCESS,
  SALARY_PAGE_CHANGE,
  UPDATE_ADMIN_INVOICE,
  UPDATE_ADMIN_INVOICE_RESULT,
  HIDE_ADMIN_SNACKBAR,
  EXPAND_ADMIN_USER,
  EXPAND_ADMIN_USER_TRUE,
  EXPAND_ADMIN_USER_FALSE,
  UPDATE_ADMIN_USER,
  UPDATE_ADMIN_USER_RESULT,
  UPDATE_ADMIN_USER_RESULT_FAILED,
  SAVE_EXPENSE,
  SAVE_EXPENSE_FAILED,
  SAVE_EXPENSE_SUCCESS,
  GET_EXPENSE_START,
  GET_EXPENSE_SUCCESS,
  GET_EXPENSE_FAILED,
  EMPTY_EXPENSE_ROWS,
  CLOSE_EXPENSE_SNACKBAR,
  EXPENSE_CHANGE_PAGE,
  POST_YEL_START,
  SAVE_ALLOWANCE,
  SAVE_ALLOWANCE_FAILED,
  SAVE_ALLOWANCE_SUCCESS,
  LOAD_ALLOWANCE_COST,
  LOAD_ALLOWANCE_COST_SUCCESS,
  LOAD_ALLOWANCE_COST_FAILED,
  ALLOWANCE_CHANGE_PAGE,
  GET_YEL_START,
  GET_YEL_SUCCESS,
  GET_YEL_FAILED,
  GET_USER_YEL_INFO,
  ENABLE_YEL_INCOME_LOCK,
  ENABLE_YEL_SELECTION_LOCK,
  SELECT_ROW_SALARY_SUCCESS,
  GET_SALARIES_SUCCESS,
  POST_SALARY,
  REGISTER_FORM_SUBMIT_SUCCESS,
  REGISTER_FORM_SUBMIT_FAILED,
  REGISTER_FORM_SUBMIT_USER_EXIST_ERROR,
  CLOSE_REGISTER_SNACKBAR,
  LOAD_REGISTER_FROM_SITE,
  LOGIN_FORM_SUBMIT_SUCCESS,
  LOGIN_FORM_SUBMIT_FAILED,
  CLOSE_LOGIN_SNACKBAR,
  CLIENT_SET,
  CLIENT_UNSET,
  LOGOUT,
  GET_LANG_FROM_SITE,
  DOWNLOAD_PDF_SUCCESS,
  DOWNLOAD_PDF_FAILED,
  GET_PROFESSION,
  GET_PROFESSION_SUCCESS,
  GET_PROFESSION_FAILED,
  GET_FINVOICE_OPERATOR,
  GET_OPERATOR_SUCCESS,
  GET_OPERATOR_FAILED,
  GET_EINVOICE_OPERATOR,
  GET_EOPERATOR_SUCCESS,
  GET_EOPERATOR_FAILED,
  SHOW_TOOLTIP,
  HIDE_TOOLTIP,
  REMOVE_EXPENSE,
  REMOVE_ALLOWANCE,
  EDIT_EXPENSE,
  EDIT_ALLOWANCE,
  GET_EXPENSE_BY_ID_SUCCESS,
  GET_ALLOWANCE_BY_ID_SUCCESS,
  SAVE_EXPENSE_UPDATE,
  CANCEL_EXPENSE_UPDATE,
  EXPENSE_UPDATE_SUCCESS,
  EXPENSE_UPDATE_FAILED,
  SAVE_ALLOWANCE_UPDATE,
  CANCEL_ALLOWANCE_UPDATE,
  CHANGE_PURCHASE_DATE,
  SAVE_SALARY_SLIP,
  CANCEL_PAY_SALARY,
  CLOSE_CUSTOMER_SNACKBAR,
  WARN_CUSTOMER_TO_DELETE,
  CANCEL_DELETE_CUSTOMER,
  GENERATE_INVOICE_PDF,
  INVOICE_DOWNLOAD_PDF,
  NAVIGATE_TO_UPDATE_BANK_INFO,
  SAVE_AND_SEND_INVOICE_PDF,
  INVOKE_EXPENSE_REMINDER,
  SET_INVOICE_ATTACHMENTS,
  REMOVE_INVOICE_ATTACHMENTS,
  RESET_PASSWORD_FORM_SUBMIT,
  RESET_PASSWORD_SUBMIT_SUCCESS,
  RESET_PASSWORD_SUBMIT_FAILED,
  HIDE_RESET_PASSWORD_SNACKBAR,
  PASSWORD_UPDATE_SUCCESS,
  PASSWORD_UPDATE_FAILED,
  CLOSE_PASSWORD_SNACKBAR,
  YEL_UPDATE_SUCCESS,
  YEL_UPDATE_FAILED,
  LOAD_USER_YEL_INFO_SUCCESS,
  LOAD_USER_YEL_INFO_FAILED,
  CLOSE_YEL_SNACKBAR,
  GENERATE_INVOICE_PDF_SUCCESS,
  GENERATE_INVOICE_PDF_FAILED,
  SEARCH_ADMIN_WAGES,
  UPDATE_ADMIN_INVOICE_STATUS,
  CANCEL_UPDATE_ADMIN_INVOICE_STATUS,
  CLOSE_DIALOG,
  CANCEL_UPDATE_ADMIN_SALARY_STATUS,
  REMOVE_PAYMENT_DIALOG,
  UPDATE_ADMIN_SALARY_STATUS,
  USER_SEARCH_PAGE_CHANGE,
  TIEDOTTEET_SEARCH_PAGE_CHANGE,
  RELEASE_INFO_SEARCH_PAGE_CHANGE,
  WARN_INVOICE_TO_PAY,
  WARN_SALARY_TO_PAY,
  CONFIRM_SALARY_TO_PAY,
  IMPORT_KASSAVIRTANEN_SALARIES,
  SALARY_SEND_TO_IR,
  CANCEL_SALARY_IR_REPORT,
  MANUAL_PAY_SALARIES,
  WARN_TO_ADD_COST,
  ADD_SALARY_SUCCESS,
  ADD_SALARY_FAILURE,
  CLOSE_SALARY_PAY_ERROR,
  UPDATE_ADMIN_INVOICE_STATUS_SUCCESS,
  UPDATE_ADMIN_SALARY_STATUS_SUCCESS,
  UPDATE_ADMIN_SALARY_STATUS_FAILED,
  UPDATE_ADMIN_BANK_PAYMENT_SUCCESS,
  UPDATE_ADMIN_BANK_PAYMENT_FAILED,
  UPDATE_ADMIN_IR_FAILED,
  GET_ADMIN_EXPENSE_REPORT_SUCCESS,
  GET_ADMIN_EXPENSE_REPORT_FAILED,
  ADMIN_ADD_NEW_UPDATES,
  ADMIN_ADD_NEW_UPDATES_SUCCESS,
  ADMIN_DELETE_COMPANY_UPDATE,
  ADMIN_DELETE_COMPANY_UPDATE_SUCCESS,
  ADMIN_GET_UPDATES,
  ADMIN_GET_UPDATES_SUCCESS,
  NO_PIKAPALKKA,
  SHOW_SALARY_PDF,
  SHOW_INVOICE_PDF,
  SHOW_REMINDER_INVOICE_PDF,
  GET_ADMIN_EXPENSE_REPORT,
  ALLOWANCE_UPDATE_SUCCESS,
  ALLOWANCE_UPDATE_FAILED,
  ALLOWANCE_UPDATE_EXCEED_LIMIT_FAILED,
  EMPTY_PASSENGER_ROWS,
  EMPTY_ALLOWANCE_INPUT_ROWS,
  INVOICE_EDIT_SUCCESS,
  LANGUAGE_CHANGE,
  UPDATE_ADMIN_INVOICE_STATUS_REJECTED,
  UPDATE_ADMIN_INVOICE_STATUS_NEW,
  UPDATE_ADMIN_INVOICE_STATUS_LOANED,
  UPDATE_ADMIN_INVOICE_STATUS_NOT_ACCEPTED,
  UPDATE_ADMIN_INVOICE_STATUS_PAID_AND_NEW_INVOICE,
  UPDATE_ADMIN_INVOICE_STATUS_PERINNASSA,
  SENT_INVOICE_REMINDER,
  VALIDATE_TOKEN,
  REFRESH_TOKEN,
  REFRESH_TOKEN_SUCCESS,
  ADD_EXPENSES_TO_INVOICE,
  UPDATE_INVOICEID_TO_EXPENSE,
  UPDATE_INVOICEID_TO_ALLOWANCE,
  SHOW_EXPENSE_DIALOG,
  CANCEL_EXPENSE_DIALOG,
  SHOW_ALLOWANCE_DIALOG,
  CANCEL_ALLOWANCE_DIALOG,
  CANCEL_INVOICE_INFO_DIALOG,
  ENABLE_EXPENSE_BACK_BTN,
  ENABLE_ALLOWANCE_BACK_BTN,
  DISABLE_EXPENSE_BACK_BTN,
  DISABLE_ALLOWANCE_BACK_BTN,
  SELECT_EXPENSE_ID,
  SELECT_ALLOWANCE_ID,
  ADD_ALLOWANCES_TO_INVOICE,
  CANCEL_EXPENSE_REMINDER,
  CHANGE_VAT_PERCENT,
  CLOSE_EXP_INVOICE_WARN_SNACK_BAR,
  CLOSE_ALLOWANCE_INVOICE_WARN_SNACK_BAR,
  GET_ADMIN_USERS_LIST,
  GET_ADMIN_USERS_LIST_SUCCESS,
  GET_ADMIN_USERS_LIST_FAIL,
  SELECT_USER,
  SELECT_USER_SUCCESS,
  UNSELECT_USER,
  GET_USER_INFO,
  GET_USER_INFO_SUCCESS,
  LOAD_INVOICE_ITEMS,
  CLOSE_LOAD_INVOICE_ITEMS,
  LOAD_EXPENSE_ITEMS,
  CLOSE_LOAD_EXPENSE_ITEMS,
  LOAD_SALARY_ITEMS,
  CLOSE_LOAD_SALARY_ITEMS,
  CLEAR_SELECTED_USER,
  CLEAR_ADDITIONAL_VEHICLE_INFO,
  SEARCH_ADMIN_IR,
  SEARCH_ADMIN_WAGES_IR_FALIED,
  SEARCH_ADMIN_WAGES_IR_SUCCESS,
  IR_SEARCH_PAGE_CHANGE,
  UPDATE_ADMIN_SALARY_STATUS_IR,
  SELECT_INVOICE_CUSTOMER,
  UPDATE_EXPENSE_SELECTED_LIST,
  WARN_NO_SSN,
  SEARCH_COMPANY_DETAILS,
  SEARCH_COMPANY_DETAILS_SUCCESS,
  LOAD_SELECTED_COMPANY,
  CLOSE_COMPANY_LISTS,
  INCREMENT_YEAR,
  DECREMENT_YEAR,
  RESET_YEAR,
  PRICE_CHANGE,
  GET_COUNTRY_LIST,
  GET_COUNTRY_LIST_SUCCESS,
  GO_TO_REVIEW,
  GO_TO_INVOICE,
  EDIT_AND_GO_TO_INVOICE,
  CLOSE_ADMIN_USER_FORMS,
  CLOSE_ADMIN_USER_FORMS_SUCCESS,
  UPDATE_ADMIN_TABLE,
  UPDATE_ADMIN_TABLE_SUCCESS,
  CANCEL_UPDATE_ADMIN_SALARY_STATUS_SUCCESS,
  GET_ADMIN_SALARY_ULOSOTTO_INFO,
  GET_ADMIN_SALARY_ULOSOTTO_INFO_SUCCESS,
  ENABLE_CANCEL_INVOICE,
  DISABLE_CANCEL_INVOICE,
  CLEAR_SALARY_SELECTION,
  SEARCH_COMPANY_INVOICES,
  GET_FIELD_OF_WORK,
  GET_FIELD_OF_WORK_SUCCESS,
  ADD_CREDIT_NOTE_INVOICE,
  ADD_CREDIT_NOTE_SUCCESS,
  ADD_CREDIT_NOTE_FAILED,
  SET_ORIGINAL_INVOICE_ID,
  LOAD_OPEN_FOR_WORK_START,
  LOAD_OPEN_FOR_WORK_SUCCESS,
  LOAD_OPEN_FOR_WORK_FAILED,
  UPDATE_OPEN_FOR_WORK_SUCCESS,
  UPDATE_OPEN_FOR_WORK_FAILED,
  UPDATE_OPEN_FOR_WORK,
  CLOSE_OPEN_FOR_WORK_SNACKBAR,
  GET_AREA_OF_EXPERTISE,
  GET_AREA_OF_EXPERTISE_SUCCESS,
  GET_AREA_OF_WORK,
  GET_AREA_OF_WORK_SUCCESS,
  UPDATE_ADMIN_INVOICE_RESULT_FAILED,
  CLOSE_ADMIN_INVOICE_FORMS,
  CLOSE_ADMIN_INVOICE_FORMS_SUCCESS,
  ADMIN_SEND_NEW_INVOICE_SUCCESS,
  ADMIN_GENERATE_PDF_SUCCESS,
  ADMIN_GENERATE_PDF_FAILED,
  SHOW_LATEST_INVOICE_PDF,
  UPDATE_TAX_CARD,
  SEARCH_ADMIN_INVOICE_ALL_ROWS_SUCCESS,
  SHIPBUILDING_INDUSTRY_TAX_CARD,
  SHIPBUILDING_INDUSTRY_TAX_CARD_SUCCESS,
  SHIPBUILDING_INDUSTRY_TAX_CARD_FAILED,
  GET_INDUSTRY_TAX_CARD,
  GET_INDUSTRY_TAX_CARD_SUCCESS,
  GET_INDUSTRY_TAX_CARD_FAILED,
  GENERATE_INDUSTRY_TAX_PDF_SUCCESS,
  GENERATE_INDUSTRY_TAX_PDF_FAILED,
  GO_TO_RIMINDER,
  CLOSE_SNACKBAR,
  // KAS-339 SELECTED_CUSTOMER_TYPE action don't use any more, use WatchField instead
  ADMIN_UPDATE_INDUSTRY_TAX_CARD_SUCCESS,
  ADMIN_UPDATE_INDUSTRY_TAX_CARD_FAILED,
  SEARCH_ADMIN_SALARY_ALL_RECORDS_SUCCESS,
  SSN_DUPLICATE,
  SEND_REFERRAL,
  SEND_REFERRAL_SUCCESS,
  SEND_REFERRAL_FAILED,
  CLOSE_REFERRAL_SNACKBAR,
  EMAIL_REFERRED_OR_REGISTERED,
  GET_REFERRAL_DISCOUNT_BY_EMAIL,
  GET_REFERRAL_DISCOUNT_BY_EMAIL_SUCCESS,
  GET_REFERRAL_DISCOUNT_BY_EMAIL_FAILED,
  CLOSE_DIALOG_DASHBOARD,
  CLOSE_DIALOG_SALARY,
  SEND_REFERRAL_CODE,
  SEND_REFERRAL_CODE_SUCCESS,
  SEND_REFERRAL_CODE_FAILED,
  GET_REFERRAL_DISCOUNT_DETAILS_SUCCESS,
  GET_REFERRAL_DISCOUNT_DETAILS_FAILED,
  CLOSE_SALARY_SNACKBAR,
  DISCOUNT_IS_NOT_USED,
  DISCOUNT_IS_NOT_USED_SUCCESS,
  DISCOUNT_IS_NOT_USED_FAILED,
  SET_ADDING_LOGO,
  SAVE_LOGO,
  SAVE_LOGO_SUCCESS,
  SAVE_LOGO_FAILED,
  GET_LOGO,
  GET_LOGO_SUCCESS,
  DELETE_LOGO,
  DELETE_LOGO_SUCCESS,
  DELETE_LOGO_FAILED,
  INVALID_LOGO,
  CLOSE_LOGO_SNACKBAR,
  NOT_OPEN_FOR_WORK,
  NOT_OPEN_FOR_WORK_SUCCESS,
  NOT_OPEN_FOR_WORK_FAILED,
  GET_ALL_ASSIGNMENTS,
  GET_ALL_ASSIGNMENTS_SUCCESS,
  GET_ALL_ASSIGNMENTS_FAILED,
  SET_TOTAL_ASSIGNMENTS,
  SET_TOTAL_APPLICATIONS,
  SET_TOTAL_WORKSHIFTS,
  APPLY_ASSIGNMENT,
  CANCEL_APPLY_ASSIGNMENT,
  SEARCH_ASSIGNMENT,
  SEARCH_ASSIGNMENT_SUCCESS,
  SEARCH_ASSIGNMENT_FAILED,
  SEND_APPLICATION,
  SEND_APPLICATION_SUCCESS,
  SEND_APPLICATION_FAILED,
  CLOSE_SUCCESS_SEND_APPLICATION,
  GET_ASSIGNMENT_OFFERED_TO_EMAIL_SUCCESS,
  GET_ASSIGNMENT_OFFERED_TO_EMAIL_FAILED,
  TRACK_APPLICATION,
  TRACK_APPLICATION_SUCCESS,
  TRACK_APPLICATION_FAILED,
  GET_ASSIGNMENT_OFFERED_TO_EMAIL,
  OPEN_SIGN_BOX,
  CANCEL_OPEN_SIGN_BOX,
  REJECT_ASSIGNMENT,
  ASK_BEFORE_REJECT_ASSIGNMENT,
  CANCEL_REJECT_ASSIGNMENT,
  REJECT_ASSIGNMENT_SUCCESS,
  GET_APPLICATION_PROFILE,
  GET_APPLICATION_PROFILE_SUCCESS,
  GET_APPLICATION_PROFILE_FAILED,
  CLOSE_APPLICATION_PROFILE,
  SIGN_AND_SEND_ASSIGNMENT,
  SIGN_AND_SEND_ASSIGNMENT_SUCCESS,
  SIGN_AND_SEND_ASSIGNMENT_FAILED,
  CLOSE_APPLICATION_SNACKBAR,
  APPLICATION_LIST_PAGE_CHANGE,
  LOAD_SIGN_SEND,
  CLOSE_LOAD_SIGN_SEND,
  EXPAND_ADMIN_SALARY,
  EXPAND_ADMIN_SALARY_TRUE,
  EXPAND_ADMIN_SALARY_FALSE,
  UPDATE_ADMIN_SALARY,
  CLOSE_ADMIN_SALARY_FORMS,
  CLOSE_ADMIN_SALARY_FORMS_SUCCESS,
  GET_REGISTERED_USERS_LIST,
  GET_REGISTERED_USERS_LIST_SUCCESS,
  GET_REGISTERED_USERS_LIST_FAILED,
  GET_INVOICE_USER_EMAIL,
  CLOSE_COMPANY_NOTIFICATION_DIALOG,
  OPEN_CUSTOMER_FORM_DIALOG,
  CLOSE_CUSTOMER_FORM_DIALOG,
  SET_READ_COMPANY_UPDATE,
  SET_READ_COMPANY_UPDATE_SUCCESS,
  SET_READ_COMPANY_UPDATE_FAILED,
  OPEN_COMPANY_NOTIFICATION_DIALOG,
  GET_USER_COMPANY_UPDATE_INFO,
  GET_USER_COMPANY_UPDATE_INFO_SUCCESS,
  GET_USER_COMPANY_UPDATE_INFO_FAILED,
  REMOVE_INVOICE_FEE_WITH_REASON,
  CANCEL_REMOVE_INVOICE_FEE_DIALOG,
  GET_USER_LIFETIME_INFO,
  GET_USER_LIFETIME_INFO_SUCCESS,
  GET_USER_LIFETIME_INFO_FAILED,
  CHANGE_ROWS_PER_PAGE,
  UPDATE_CELEBRATE_STATUS,
  UPDATE_CELEBRATE_STATUS_SUCCESS,
  UPDATE_CELEBRATE_STATUS_FAILED,
  GET_INVOICE_AND_SALARY_DETAIL_MONTHLY,
  GET_INVOICE_AND_SALARY_DETAIL_MONTHLY_SUCCESS,
  GET_INVOICE_AND_SALARY_DETAIL_MONTHLY_FAILED,
  GET_WORKSHIFT_USER,
  GET_WORKSHIFT_USER_SUCCESS,
  GET_WORKSHIFT_USER_FAILED,
  GET_BILLABLE_HOUR_USER,
  GET_BILLABLE_HOUR_USER_SUCCESS,
  GET_BILLABLE_HOUR_USER_FAILED,
  UPDATE_USER_WORKSHIFT,
  UPDATE_USER_WORKSHIFT_SUCCESS,
  UPDATE_USER_WORKSHIFT_FAILED,
  REQUEST_EDIT_ACTUAL_HOUR,
  REQUEST_EDIT_ACTUAL_HOUR_SUCCESS,
  REQUEST_EDIT_ACTUAL_HOUR_FAILED,
  GET_EMPLOYER_WORKSHIFT,
  GET_EMPLOYER_WORKSHIFT_SUCCESS,
  GET_EMPLOYER_WORKSHIFT_FAILED,
  WORKSHIFT_BY_EMPLOYER,
  GET_JOURNAL,
  GET_JOURNAL_SUCCESS,
  GET_JOURNAL_FAILED,
  GET_JOURNAL_EDIT,
  GET_JOURNAL_EDIT_SUCCESS,
  GET_JOURNAL_EDIT_FAILED,
  DELETE_JOURNAL,
  DELETE_JOURNAL_SUCCESS,
  DELETE_JOURNAL_FAILED,
  WARN_DELETE_JOURNAL,
  CLOSE_WARN_DELETE_JOURNAL,
  ADD_JOURNAL_DETAIL,
  ADD_JOURNAL_DETAIL_SUCCESS,
  ADD_JOURNAL_DETAIL_FAILED,
  UPDATE_JOURNAL_DETAIL,
  UPDATE_JOURNAL_DETAIL_SUCCESS,
  UPDATE_JOURNAL_DETAIL_FAILED,
  CANCEL_JOURNAL_EDIT,
  ATTACH_WORKSHIFT_JOURNAL_ID,
  ATTACH_WORKSHIFT_JOURNAL_ID_SUCCESS,
  UPDATE_ATTACH_JOURNAL_TO_INVOICE,
  UPDATE_ATTACH_JOURNAL_TO_INVOICE_SUCCESS,
  UPDATE_ATTACH_JOURNAL_TO_INVOICE_FAILED,
  GET_ATTACHED_JOURNAL_PDF_DATA,
  CLOSE_USER_WORKSHIFT_SNACKBAR,
  DOWNLOAD_CUSTOMERS_REPORT,
  SET_CUSTOMER_FORM_READONLY,
  COPY_ALLOWANCE,
  CLEAR_ATTACH_WORKSHIFT_JOURNAL_ID,
  UPDATE_USER_EMAIL,
  UPDATE_USER_EMAIL_SUCCESS,
  UPDATE_USER_EMAIL_FAILED,
  UPDATE_VIEW_ASSIGNMENT,
  PIN_ASSIGNMENT,
  PIN_ASSIGNMENT_SUCCESS,
  PIN_ASSIGNMENT_FAILED,
  SEARCH_COMPANY_SALARIES,
  SEE_MY_APPLICATION,
  VERIFY_USER_PROFILE,
  SEARCH_COMPANY_CUSTOMERS,
  SHOW_INVOICE_FORM_DIALOG,
  CLOSE_INVOICE_FORM_DIALOG,
  UPDATE_VIEW_APPLICATION,
  PIN_APPLICATION,
  PIN_APPLICATION_SUCCESS,
  PIN_APPLICATION_FAILED,
  WORKSHIFT_PAGE_CHANGE,
  UPDATE_VIEW_WORKSHIFT,
  PIN_WORKSHIFT,
  PIN_WORKSHIFT_SUCCESS,
  PIN_WORKSHIFT_FAILED,
  RESET_INVOICES,
  CLEAR_INVOICE_EDIT_VALUES
} from '../constants/index'

//dashboard overview years
export const incrementYear = () => ({ type: INCREMENT_YEAR })
export const decrementYear = () => ({ type: DECREMENT_YEAR })
export const resetYear = () => ({ type: RESET_YEAR })

//search company details actions
export const searchCompanyDetails = (companyName) => ({
  type: SEARCH_COMPANY_DETAILS,
  companyName
})

export const searchCompanyDetailsSuccess = (companyLists) => ({
  type: SEARCH_COMPANY_DETAILS_SUCCESS,
  companyLists
})

// fetch company addresses
export const loadSelectedCompany = (selectedCompany, formName) => ({
  type: LOAD_SELECTED_COMPANY,
  selectedCompany,
  formName
})

//close dialog box
export const closeCompanyLists = () => ({
  type: CLOSE_COMPANY_LISTS
})

export const removeInvoiceRow = (rowNumber) => ({
  type: REMOVE_INVOICE_ROW,
  rowNumber
})

// KAS-339 SELECTED_CUSTOMER_TYPE action don't use any more, use WatchField instead
export const saveAndSendInvoice = (formValues) => ({
  type: SAVE_AND_SEND_INVOICE,
  formValues
})
export const saveAndSendInvoiceSuccess = (result) => ({
  type: SAVE_AND_SEND_INVOICE_SUCCESS,
  result
})
export const saveAndSendInvoicePDF = (formValues) => ({
  type: SAVE_AND_SEND_INVOICE_PDF,
  formValues
})
export const InvokeExpenseReminder = () => ({ type: INVOKE_EXPENSE_REMINDER })
export const setInvoiceAttachments = (attachments) => ({
  type: SET_INVOICE_ATTACHMENTS,
  attachments
})
export const removeInvoiceAttachments = () => ({
  type: REMOVE_INVOICE_ATTACHMENTS
})
export const quantityChange = (val, rowNumber) => ({
  type: QUANTITY_CHANGE,
  val,
  rowNumber
})
export const quantityPriceChange = (val, rowNumber) => ({
  type: QUANTITY_PRICE_CHANGE,
  val,
  rowNumber
})
export const onInvoiceReview = () => ({ type: ON_INVOICE_REVIEW })

export const calculateDuedate = (date) => ({
  type: CALCULATE_INVOICE_DUEDATE,
  date
})

export const closeTaxCardSnackbar = () => ({ type: CLOSE_TAX_CARD_SNACKBAR })
export const closeTaxCardErrorSnackbar = () => ({
  type: CLOSE_TAX_CARD_ERROR_SNACKBAR
})
export const closeTaxCardSpinner = () => ({ type: CLOSE_TAX_CARD_SPINNER })
export const getTaxCard = (userData) => ({ type: GET_TAX_CARD, userData })
export const updateTaxCard = (formValues, disableLoader) => ({
  type: UPDATE_TAX_CARD,
  formValues,
  disableLoader
})
export const updateTaxCardSuccess = (disableSnackbar) => ({
  type: UPDATE_TAX_CARD_SUCCESS,
  disableSnackbar
})
export const updateTaxCardFailed = (disableSnackbar, noTaxCardFound) => ({
  type: UPDATE_TAX_CARD_FAILED,
  disableSnackbar,
  noTaxCardFound
})
export const postYelStart = (formValues) => ({
  type: POST_YEL_START,
  formValues
})
export const getYelStart = () => ({ type: GET_YEL_START })
export const getYelSuccess = (yels) => ({ type: GET_YEL_SUCCESS, yels })
export const getYelFailed = () => ({ type: GET_YEL_FAILED })
export const getUserYelInfo = (userData) => ({
  type: GET_USER_YEL_INFO,
  userData
})
export const enableYelIncomeLock = () => ({ type: ENABLE_YEL_INCOME_LOCK })
export const enableYelSelectionLock = () => ({
  type: ENABLE_YEL_SELECTION_LOCK
})
export const getInvoicesStart = (data) => ({ type: GET_INVOICES_START, data })
export const getInvoicesSuccess = (invoices, customerResult) => ({
  type: GET_INVOICES_SUCCESS,
  invoices,
  customerResult
})
export const getInvoicesFailed = (error) => ({
  type: GET_INVOICES_FAILED,
  error
})

export const getProfessions = () => ({ type: GET_PROFESSION })
export const getFinvoiceOperator = () => ({ type: GET_FINVOICE_OPERATOR })
export const getEinvoiceOperator = () => ({ type: GET_EINVOICE_OPERATOR })
export const getEOperatorSuccess = (operators) => ({
  type: GET_EOPERATOR_SUCCESS,
  operators
})
export const getEOperatorFailed = (error) => ({
  type: GET_EOPERATOR_FAILED,
  error
})
export const getProfessionSuccess = (profession) => ({
  type: GET_PROFESSION_SUCCESS,
  profession
})
export const getOperatorSuccess = (operators) => ({
  type: GET_OPERATOR_SUCCESS,
  operators
})
export const getOperatorFailed = (error) => ({
  type: GET_OPERATOR_FAILED,
  error
})
export const getProfessionFailed = (error) => ({
  type: GET_PROFESSION_FAILED,
  error
})

export const saveInvoiceSuccess = (result) => ({
  type: SAVE_INVOICE_SUCCESS,
  result
})
export const reviewInvoiceEditSuccess = (result) => ({
  type: REVIEW_INVOICE_EDIT_SUCCESS,
  result
})
export const reviewInvoiceEditSendSuccess = (result) => ({
  type: REVIEW_INVOICE_EDIT_SEND_SUCCESS,
  result
})
export const updateInvoiceFailed = () => ({ type: UPDATE_INVOICE_FAILED })
export const invoiceEditSuccess = (result) => ({
  type: INVOICE_EDIT_SUCCESS,
  result
})
export const saveInvoiceFailed = (error) => ({
  type: SAVE_INVOICE_FAILED,
  error
})
export const closeInvoiceReviewSnackBar = () => ({
  type: CLOSE_INVOICE_REVIEW_SNACKBAR
})
export const removeInvoice = (invoice_id, attached_journal_id) => ({
  type: REMOVE_INVOICE,
  invoice_id,
  attached_journal_id
})
export const warnInvoiceToDelete = (selected, attached_journal_id) => ({
  type: WARN_INVOICE_TO_DELETE,
  selected,
  attached_journal_id
})
export const reminderInvoiceDownloadPDF = (invoice_id) => ({
  type: REMINDER_INVOICE_DOWNLOAD_PDF,
  invoice_id
})
export const cancelDeleteInvoice = () => ({ type: CANCEL_DELETE_INVOICE })
export const goToReview = (formValues) => ({ type: GO_TO_REVIEW, formValues })
export const goToInvoice = () => ({ type: GO_TO_INVOICE })
export const editAndGoToInvoice = (formValues, invoiceEdit) => ({
  type: EDIT_AND_GO_TO_INVOICE,
  formValues,
  invoiceEdit
})
export const disableCancelInvoice = () => ({ type: DISABLE_CANCEL_INVOICE })
export const enableCancelInvoice = () => ({ type: ENABLE_CANCEL_INVOICE })
export const copyInvoice = (invoice_id) => ({ type: COPY_INVOICE, invoice_id })
export const cancelEditInvoice = () => ({ type: CANCEL_EDIT_INVOICE })
export const editInvoice = (invoice_id, expenses) => ({
  type: EDIT_INVOICE,
  invoice_id,
  expenses
})
export const getInvoiceByIdSuccess = (result) => ({
  type: GET_INVOICE_BY_ID_SUCCESS,
  result
})
export const copyInvoiceSuccess = (result) => ({
  type: COPY_INVOICE_SUCCESS,
  result
})
export const invoicePageChange = (selected) => ({
  type: INVOICE_PAGE_CHANGE,
  selected
})
export const changeVATPercent = (value, fields) => ({
  type: CHANGE_VAT_PERCENT,
  value,
  fields
})

export const saveInvoiceDraft = (formValues) => ({
  type: SAVE_INVOICE_DRAFT,
  formValues
})
export const generateInvoicePDFSuccess = (result) => ({
  type: GENERATE_INVOICE_PDF_SUCCESS,
  result
})
export const generateInvoicePDFFailed = (error) => ({
  type: GENERATE_INVOICE_PDF_FAILED,
  error
})
export const changeInvoiceBillingDate = (date) => ({
  type: CHANGE_INVOICE_BILLING_DATE,
  date
})
export const downloadPDFSuccess = () => ({ type: DOWNLOAD_PDF_SUCCESS })
export const downloadPDFFailed = () => ({ type: DOWNLOAD_PDF_FAILED })
export const showTooltip = () => ({ type: SHOW_TOOLTIP })
export const hideTooltip = () => ({ type: HIDE_TOOLTIP })
export const generateInvoicePDF = (invoice_id) => ({
  type: GENERATE_INVOICE_PDF,
  invoice_id
})
export const invoiceDownloadPDF = (invoice_id) => ({
  type: INVOICE_DOWNLOAD_PDF,
  invoice_id
})
export const addCreditNoteInvoice = (invoice_id) => ({
  type: ADD_CREDIT_NOTE_INVOICE,
  invoice_id
})
export const addCreditNoteSuccess = (result) => ({
  type: ADD_CREDIT_NOTE_SUCCESS,
  result
})
export const addCreditNoteFailed = () => ({ type: ADD_CREDIT_NOTE_FAILED })
export const setOriginalInvoiceId = (invoice_id) => ({
  type: SET_ORIGINAL_INVOICE_ID,
  invoice_id
})
export const navigateToUpdateBankInfo = (formValues) => ({
  type: NAVIGATE_TO_UPDATE_BANK_INFO,
  formValues
})

export const cancelExpenseReminder = () => ({ type: CANCEL_EXPENSE_REMINDER })
export const selectInvoiceCustomer = (customer, formValues) => ({
  type: SELECT_INVOICE_CUSTOMER,
  customer,
  formValues
})

export const clearAttachWorkshiftJournalId = () => ({
  type: CLEAR_ATTACH_WORKSHIFT_JOURNAL_ID
})
export const attachWorkshiftJournalId = (journal_id) => ({
  type: ATTACH_WORKSHIFT_JOURNAL_ID,
  journal_id
})
export const attachWorkshiftJournalIdSuccess = (result) => ({
  type: ATTACH_WORKSHIFT_JOURNAL_ID_SUCCESS,
  result
})
export const updateAttachJournalToInvoice = (
  journal_id,
  invoice_id,
  attachOption
) => ({
  type: UPDATE_ATTACH_JOURNAL_TO_INVOICE,
  journal_id,
  invoice_id,
  attachOption
})
export const updateAttachJournalToInvoiceSuccess = (result) => ({
  type: UPDATE_ATTACH_JOURNAL_TO_INVOICE_SUCCESS,
  result
})
export const updateAttachJournalToInvoiceFailed = (error) => ({
  type: UPDATE_ATTACH_JOURNAL_TO_INVOICE_FAILED,
  error
})
export const getAttachedJournalPdfData = (data) => ({
  type: GET_ATTACHED_JOURNAL_PDF_DATA,
  data
})

export const getExpenseStart = (data) => ({ type: GET_EXPENSE_START, data })
export const getExpenseSuccess = (expenses, allowances) => ({
  type: GET_EXPENSE_SUCCESS,
  expenses,
  allowances
})
export const getExpenseFailed = (error) => ({ type: GET_EXPENSE_FAILED, error })
export const calculateDistance = (formValues) => ({
  type: CALCULATE_DISTANCE,
  formValues
})
export const clearAdditionalVehicleInfo = () => ({
  type: CLEAR_ADDITIONAL_VEHICLE_INFO
})

export const selectExpenseId = (expenseSelected, invoice_expense_id) => ({
  type: SELECT_EXPENSE_ID,
  expenseSelected,
  invoice_expense_id
})
export const selectAllowanceId = (allowanceCheckSelected, id) => ({
  type: SELECT_ALLOWANCE_ID,
  allowanceCheckSelected,
  id
})

export const updateInvoiceIdToInfoSuccess = () => ({
  type: UPDATE_INVOICEID_TO_INFO_SUCCESS
})
export const updateInvoiceIdToInfoExceedLimitFailed = () => ({
  type: UPDATE_INVOICEID_TO_INFO_EXCEED_LIMIT_FAILED
})
export const updateInvoiceIdToInfoFailed = () => ({
  type: UPDATE_INVOICEID_TO_INFO_FAILED
})

export const updateSelectedExpenseIds = () => ({
  type: UPDATE_SELECTED_EXPENSE_IDS
})
export const updateExpenseSelectedList = (list) => ({
  type: UPDATE_EXPENSE_SELECTED_LIST,
  list
})
export const updateSelectedAllowanceIds = () => ({
  type: UPDATE_SELECTED_ALLOWANCE_IDS
})

export const saveExpense = (formValues) => ({ type: SAVE_EXPENSE, formValues })
export const saveExpenseFailed = (errorStatus) => ({
  type: SAVE_EXPENSE_FAILED,
  errorStatus
})
export const saveExpenseSuccess = (result) => ({
  type: SAVE_EXPENSE_SUCCESS,
  result
})
export const emptyExpenseRows = () => ({ type: EMPTY_EXPENSE_ROWS })
export const closeExpenseSnackBar = () => ({ type: CLOSE_EXPENSE_SNACKBAR })
export const expensePageChange = (selected) => ({
  type: EXPENSE_CHANGE_PAGE,
  selected
})
export const saveAllowance = (formValues) => ({
  type: SAVE_ALLOWANCE,
  formValues
})
export const saveAllowanceSuccess = (result) => ({
  type: SAVE_ALLOWANCE_SUCCESS,
  result
})
export const saveAllowanceFailed = (error) => ({
  type: SAVE_ALLOWANCE_FAILED,
  error
})
export const loadAllowanceCost = (year) => ({ type: LOAD_ALLOWANCE_COST, year })
export const loadAllowanceCostSuccess = (result) => ({
  type: LOAD_ALLOWANCE_COST_SUCCESS,
  result
})
export const loadAllowanceCostFailed = (error) => ({
  type: LOAD_ALLOWANCE_COST_FAILED,
  error
})
export const allowancePageChange = (selected) => ({
  type: ALLOWANCE_CHANGE_PAGE,
  selected
})
export const removeExpense = (index, invoice_expense_id) => ({
  type: REMOVE_EXPENSE,
  index,
  invoice_expense_id
})
export const removeAllowance = (index, id) => ({
  type: REMOVE_ALLOWANCE,
  index,
  id
})
export const closeWarnExpInvoiceSnackbar = () => ({
  type: CLOSE_EXP_INVOICE_WARN_SNACK_BAR
})
//export const closeExpInvoiceSnackbar = () => ({ type: CLOSE_EXP_INVOICE_SNACK_BAR})
export const closeWarnAllowInvoiceSnackbar = () => ({
  type: CLOSE_ALLOWANCE_INVOICE_WARN_SNACK_BAR
})
//export const closeAllowInvoiceSnackbar = () => ({ type: CLOSE_ALLOWANCE_INVOICE_SNACK_BAR})
export const editExpense = (index, invoice_expense_id) => ({
  type: EDIT_EXPENSE,
  index,
  invoice_expense_id
})
export const editAllowance = (index, id) => ({
  type: EDIT_ALLOWANCE,
  index,
  id
})
export const getExpenseByIdSuccess = (result) => ({
  type: GET_EXPENSE_BY_ID_SUCCESS,
  result
})
export const getAllowanceByIdSuccess = (result) => ({
  type: GET_ALLOWANCE_BY_ID_SUCCESS,
  result
})
export const saveExpenseUpdate = (formValues) => ({
  type: SAVE_EXPENSE_UPDATE,
  formValues
})
export const expenseUpdateSuccess = (result) => ({
  type: EXPENSE_UPDATE_SUCCESS,
  result
})
export const expenseUpdateFailed = (error) => ({
  type: EXPENSE_UPDATE_FAILED,
  error
})
export const allowanceUpdateSuccess = (result) => ({
  type: ALLOWANCE_UPDATE_SUCCESS,
  result
})
export const allowanceUpdateFailed = (error) => ({
  type: ALLOWANCE_UPDATE_FAILED,
  error
})
export const allowanceUpdateExceedLimitFailed = (error) => ({
  type: ALLOWANCE_UPDATE_EXCEED_LIMIT_FAILED,
  error
})
export const cancelExpenseUpdate = () => ({ type: CANCEL_EXPENSE_UPDATE })
export const saveAllowanceUpdate = (formValues) => ({
  type: SAVE_ALLOWANCE_UPDATE,
  formValues
})
export const cancelAllowanceUpdate = () => ({ type: CANCEL_ALLOWANCE_UPDATE })
export const changeExpensePurchaseDate = (date) => ({
  type: CHANGE_PURCHASE_DATE,
  date
})
export const emptyPassengerRows = () => ({ type: EMPTY_PASSENGER_ROWS })
export const emptyAllowanceInputRows = () => ({
  type: EMPTY_ALLOWANCE_INPUT_ROWS
})

export const addNewCustomer = (values) => ({ type: ADD_NEW_CUSTOMER, values })
export const addCustomerSuccess = (result) => ({
  type: ADD_CUSTOMER_SUCCESS,
  result
})
export const addCustomerFailed = (error) => ({
  type: ADD_CUSTOMER_FAILED,
  error
})
export const openCustomerFormDialog = () => ({
  type: OPEN_CUSTOMER_FORM_DIALOG
})
export const closeCustomerFormDialog = () => ({
  type: CLOSE_CUSTOMER_FORM_DIALOG
})
export const removeCustomer = (id) => ({ type: REMOVE_CUSTOMER, id })
export const getCustomerById = (id) => ({ type: GET_CUSTOMER_BY_ID, id })
export const getCustomerByIdSuccess = (result) => ({
  type: GET_CUSTOMER_BY_ID_SUCCESS,
  result
})
export const saveCustomerUpdate = (values) => ({
  type: SAVE_CUSTOMER_UPDATE,
  values
})
export const cancelCustomerUpdate = () => ({ type: CANCEL_CUSTOMER_UPDATE })
export const addNewCustomerInvoice = (id) => ({
  type: ADD_NEW_CUSTOMER_INVOICE,
  id
})
export const addNewCustomerInvoiceSuccess = (result) => ({
  type: ADD_NEW_CUSTOMER_INVOICE_SUCCESS,
  result
})
export const closeCustomerSnackBar = () => ({ type: CLOSE_CUSTOMER_SNACKBAR })
export const warnCustomerToDelete = (selected) => ({
  type: WARN_CUSTOMER_TO_DELETE,
  selected
})
export const cancelDeleteCustomer = () => ({ type: CANCEL_DELETE_CUSTOMER })

export const getCustomersStart = (data) => ({ type: GET_CUSTOMERS_START, data })
export const getCustomersSuccess = (result) => ({
  type: GET_CUSTOMERS_SUCCESS,
  result
})
export const customerPageChange = (selected) => ({
  type: CUSTOMER_PAGE_CHANGE,
  selected
})

export const checkAuthInfo = () => ({ type: CHECK_AUTH_INFO })
export const checkAuthInfoSuccess = (result) => ({
  type: CHECK_AUTH_INFO_SUCCESS,
  result
})
export const checkAuthInfoFailed = (error) => ({
  type: CHECK_AUTH_INFO_FAILED,
  error
})
export const getCustomersChart = (data) => ({ type: GET_CUSTOMERS_CHART, data })
export const getCustomersChartSuccess = (result) => ({
  type: GET_CUSTOMERS_CHART_SUCCESS,
  result
})
export const getCustomersChartFailed = (error) => ({
  type: GET_CUSTOMERS_CHART_FAILED,
  error
})
export const getInvoiceChart = (data) => ({ type: GET_INVOICE_CHART, data })
export const getInvoiceChartSuccess = (result) => ({
  type: GET_INVOICE_CHART_SUCCESS,
  result
})
export const getInvoiceChartFailed = (error) => ({
  type: GET_INVOICE_CHART_FAILED,
  error
})
export const getUserTaxInfo = (data) => ({ type: GET_USER_TAX_INFO, data })
export const getUserTaxInfoSuccess = (result) => ({
  type: GET_USER_TAX_INFO_SUCCESS,
  result
})
export const getCompanyUpdates = () => ({ type: GET_COMPANY_UPDATES })
export const getCompanyUpdatesSuccess = (result) => ({
  type: GET_COMPANY_UPDATES_SUCCESS,
  result
})

export const getInvoiceAndSalaryDetailMonthly = (data) => ({
  type: GET_INVOICE_AND_SALARY_DETAIL_MONTHLY,
  data
})
export const getInvoiceAndSalaryDetailMonthlySuccess = (
  monthly_invoicing,
  gross_salary,
  raised_salary
) => ({
  type: GET_INVOICE_AND_SALARY_DETAIL_MONTHLY_SUCCESS,
  monthly_invoicing,
  gross_salary,
  raised_salary
})
export const getInvoiceAndSalaryDetailMonthlyFailed = (error) => ({
  type: GET_INVOICE_AND_SALARY_DETAIL_MONTHLY_FAILED,
  error
})
export const onRenewToken = (result) => ({ type: GET_RENEW_TOKEN, result })
export const onTokenValidation = () => ({ type: TOKEN_VALIDATION })

export const setReadCompanyUpdate = (data) => ({
  type: SET_READ_COMPANY_UPDATE,
  data
})
export const setReadCompanyUpdateSuccess = (result) => ({
  type: SET_READ_COMPANY_UPDATE_SUCCESS,
  result
})
export const setReadCompanyUpdateFailed = (error) => ({
  type: SET_READ_COMPANY_UPDATE_FAILED,
  error
})
export const getUserCompanyUpdateInfo = (data) => ({
  type: GET_USER_COMPANY_UPDATE_INFO,
  data
})
export const getUserCompanyUpdateInfoSuccess = (result) => ({
  type: GET_USER_COMPANY_UPDATE_INFO_SUCCESS,
  result
})
export const getUserCompanyUpdateInfoFailed = (error) => ({
  type: GET_USER_COMPANY_UPDATE_INFO_FAILED,
  error
})
export const getUserLifeTimeInfo = (data) => ({
  type: GET_USER_LIFETIME_INFO,
  data
})
export const getUserLifeTimeInfoSuccess = (result) => ({
  type: GET_USER_LIFETIME_INFO_SUCCESS,
  result
})
export const getUserLifeTimeInfoFailed = (error) => ({
  type: GET_USER_LIFETIME_INFO_FAILED,
  error
})
export const updateCelebrationStatus = () => ({
  type: UPDATE_CELEBRATE_STATUS
})
export const updateCelebrationStatusSuccess = (result) => ({
  type: UPDATE_CELEBRATE_STATUS_SUCCESS,
  result
})
export const updateCelebrationStatusFailed = (error) => ({
  type: UPDATE_CELEBRATE_STATUS_FAILED,
  error
})

// KAS-336 Referral code
export const sendReferral = (data) => ({
  type: SEND_REFERRAL,
  data
})
export const sendReferralSuccess = (data) => ({
  type: SEND_REFERRAL_SUCCESS,
  data
})
export const sendReferralFailed = (error) => ({
  type: SEND_REFERRAL_FAILED,
  error
})
export const emailReferredOrRegistered = () => ({
  type: EMAIL_REFERRED_OR_REGISTERED
})
export const closeRererralSnackbar = () => ({
  type: CLOSE_REFERRAL_SNACKBAR
})
// Get referrral discount by email
export const getReferralDiscountByEmail = (data) => ({
  type: GET_REFERRAL_DISCOUNT_BY_EMAIL,
  data
})
export const getReferralDiscountByEmailSuccess = (data) => ({
  type: GET_REFERRAL_DISCOUNT_BY_EMAIL_SUCCESS,
  data
})
export const getReferralDiscountByEmailFailed = (error) => ({
  type: GET_REFERRAL_DISCOUNT_BY_EMAIL_FAILED,
  error
})
export const closeDialogDashboard = () => ({
  type: CLOSE_DIALOG_DASHBOARD
})
export const closeDialogSalary = () => ({
  type: CLOSE_DIALOG_SALARY
})
export const closeSalarySnackbar = () => ({
  type: CLOSE_SALARY_SNACKBAR
})
export const sendReferralCode = (data) => ({
  type: SEND_REFERRAL_CODE,
  data
})
export const sendReferralCodeSuccess = (data) => ({
  type: SEND_REFERRAL_CODE_SUCCESS,
  data
})
export const sendReferralCodeFailed = (error) => ({
  type: SEND_REFERRAL_CODE_FAILED,
  error
})
export const getReferralDiscountDetailsSuccess = (data) => ({
  type: GET_REFERRAL_DISCOUNT_DETAILS_SUCCESS,
  data
})
export const getReferralDiscountDetailsFailed = (error) => ({
  type: GET_REFERRAL_DISCOUNT_DETAILS_FAILED,
  error
})
export const discountIsNotUsed = () => ({
  type: DISCOUNT_IS_NOT_USED
})
export const discountIsNotUsedSuccess = (data) => ({
  type: DISCOUNT_IS_NOT_USED_SUCCESS,
  data
})
export const discountIsNotUsedFailed = (error) => ({
  type: DISCOUNT_IS_NOT_USED_FAILED,
  error
})

// end

export const updateProfile = (formValues) => ({
  type: UPDATE_PROFILE,
  formValues
})
export const passwordUpdate = (formValues) => ({
  type: ON_PASSWORD_UPDATE,
  formValues
})
export const passwordUpdateSuccess = (result) => ({
  type: PASSWORD_UPDATE_SUCCESS,
  result
})
export const passwordUpdateFailed = (error) => ({
  type: PASSWORD_UPDATE_FAILED,
  error
})
export const yelUpdateSuccess = (result) => ({
  type: YEL_UPDATE_SUCCESS,
  result
})
export const yelUpdateFailed = (error) => ({ type: YEL_UPDATE_FAILED, error })
export const loadProfileStart = (data) => ({ type: LOAD_PROFILE_START, data })
export const closeProfileSnackbar = () => ({ type: CLOSE_PROFILE_SNACKBAR })

export const updateProfileSuccess = (result) => ({
  type: UPDATE_PROFILE_SUCCESS,
  result
})

export const updateProfileFailed = () => ({ type: UPDATE_PROFILE_FAILED })
export const loadProfileSuccess = (result) => ({
  type: LOAD_PROFILE_SUCCESS,
  result
})
export const loadProfileFailed = (error) => ({
  type: LOAD_PROFILE_FAILED,
  error
})
export const ssnDuplicate = (result) => ({
  type: SSN_DUPLICATE,
  result
})
export const closePasswordSnackbar = () => ({ type: CLOSE_PASSWORD_SNACKBAR })
export const closeYelSnackbar = () => ({ type: CLOSE_YEL_SNACKBAR })
export const loadUserYelInfoSuccess = (result) => ({
  type: LOAD_USER_YEL_INFO_SUCCESS,
  result
})
export const loadUserYelInfoFailed = (error) => ({
  type: LOAD_USER_YEL_INFO_FAILED,
  error
})
export const resetScrollToSSN = () => ({ type: RESET_SCROLL_TO_SSN })

//export const loginFormSubmit = (email, password) => ({ type: LOGIN_FORM_SUBMIT, email, password })

export const loginFormSubmit = (values) => ({ type: LOGIN_FORM_SUBMIT, values })

export const loginFormSubmitSuccess = () => ({
  type: LOGIN_FORM_SUBMIT_SUCCESS
})
export const loginFormSubmitFailed = (error) => ({
  type: LOGIN_FORM_SUBMIT_FAILED,
  error
})
export const closeLoginSnackbar = () => ({ type: CLOSE_LOGIN_SNACKBAR })
export const setClient = (token) => ({ type: CLIENT_SET, token })
export const unsetClient = () => ({ type: CLIENT_UNSET })
export const logout = () => ({ type: LOGOUT })
export const getLangFromSite = () => ({ type: GET_LANG_FROM_SITE })
export const resetPasswordFormSubmit = (formValues) => ({
  type: RESET_PASSWORD_FORM_SUBMIT,
  formValues
})
export const resetPasswordSubmitSuccess = () => ({
  type: RESET_PASSWORD_SUBMIT_SUCCESS
})
export const resetPasswordSubmitFailed = () => ({
  type: RESET_PASSWORD_SUBMIT_FAILED
})
export const hideResetPasswordSnackbar = () => ({
  type: HIDE_RESET_PASSWORD_SNACKBAR
})

export const registerFormSubmit = (values) => ({
  type: REGISTER_FORM_SUBMIT,
  values
})
export const registerFormSubmitSuccess = (result) => ({
  type: REGISTER_FORM_SUBMIT_SUCCESS,
  result
})
export const registerFormSubmitFailed = (error) => ({
  type: REGISTER_FORM_SUBMIT_FAILED,
  error
})
export const registerFormSubmitUserExistError = (error) => ({
  type: REGISTER_FORM_SUBMIT_USER_EXIST_ERROR,
  error
})
export const closeRegisterSnackbar = () => ({ type: CLOSE_REGISTER_SNACKBAR })
export const loadSignUpFromSite = () => ({ type: LOAD_REGISTER_FROM_SITE })

export const changeAdminMenu = (value) => ({ type: CHANGE_ADMIN_MENU, value })
export const searchAdminUsers = (formValues) => ({
  type: SEARCH_ADMIN_USERS,
  formValues
})
export const searchAdminUsersSuccess = (result) => ({
  type: SEARCH_ADMIN_USERS_SUCCESS,
  result
})
export const searchAdminUsersFailed = () => ({
  type: SEARCH_ADMIN_USERS_FAILED
})
export const closeAdminUserForms = () => ({
  type: CLOSE_ADMIN_USER_FORMS
})
export const closeAdminUserFormsSuccess = () => ({
  type: CLOSE_ADMIN_USER_FORMS_SUCCESS
})
export const closeAdminInvoiceForms = () => ({
  type: CLOSE_ADMIN_INVOICE_FORMS
})
export const closeAdminInvoiceFormsSuccess = () => ({
  type: CLOSE_ADMIN_INVOICE_FORMS_SUCCESS
})
export const searchAdminWagesSuccess = (
  result,
  totalSalariesCount,
  selectedPage,
  refreshSearch,
  salarySearchSummary,
  adminSalaryPageSize
) => ({
  type: SEARCH_ADMIN_WAGES_SUCCESS,
  result,
  totalSalariesCount,
  selectedPage,
  refreshSearch,
  salarySearchSummary,
  adminSalaryPageSize
})
export const searchAdminWagesFailed = () => ({
  type: SEARCH_ADMIN_WAGES_FAILED
})
export const searchAdminIRWagesSuccess = (result) => ({
  type: SEARCH_ADMIN_WAGES_IR_SUCCESS,
  result
})
export const searchAdminIRWagesFailed = (result) => ({
  type: SEARCH_ADMIN_WAGES_IR_FALIED,
  result
})
export const expandAdminUser = (expanded, uuid) => ({
  type: EXPAND_ADMIN_USER,
  expanded,
  uuid
})
export const expandAdminUserTrue = (result, taxCard, industryTaxInfo) => ({
  type: EXPAND_ADMIN_USER_TRUE,
  result,
  taxCard,
  industryTaxInfo
})
export const expandAdminUserFalse = (uuid) => ({
  type: EXPAND_ADMIN_USER_FALSE,
  uuid
})
export const updateAdminUser = (formValues) => ({
  type: UPDATE_ADMIN_USER,
  formValues
})
export const updateAdminUserResult = () => ({ type: UPDATE_ADMIN_USER_RESULT })
export const updateAdminUserResultFailed = () => ({
  type: UPDATE_ADMIN_USER_RESULT_FAILED
})
export const searchAdminInvoice = (
  selectedPage,
  refreshSearch,
  formValues
) => ({
  type: SEARCH_ADMIN_INVOICE,
  selectedPage,
  refreshSearch,
  formValues
})
export const searchAdminInvoiceSuccess = (
  invoices,
  totalInvoiceCount,
  selectedPage,
  refreshSearch,
  searchInvoiceSummaryResult,
  adminInvoicePageSize
) => ({
  type: SEARCH_ADMIN_INVOICE_SUCCESS,
  invoices,
  totalInvoiceCount,
  selectedPage,
  refreshSearch,
  searchInvoiceSummaryResult,
  adminInvoicePageSize
})
export const searchAdminInvoiceFailed = () => ({
  type: SEARCH_ADMIN_INVOICE_FAILED
})
export const expandAdminInvoice = (
  expanded,
  invoice_id,
  partial_invoice_id,
  uuid
) => ({
  type: EXPAND_ADMIN_INVOICE,
  expanded,
  invoice_id,
  partial_invoice_id,
  uuid
})
export const expandAdminInvoiceTrue = (result, dueInvoiceIds) => ({
  type: EXPAND_ADMIN_INVOICE_TRUE,
  result,
  dueInvoiceIds
})
export const expandAdminInvoiceFalse = (invoice_id, uuid) => ({
  type: EXPAND_ADMIN_INVOICE_FALSE,
  invoice_id,
  uuid
})
export const updateAdminInvoice = (formValues) => ({
  type: UPDATE_ADMIN_INVOICE,
  formValues
})
export const updateAdminInvoiceResult = (result) => ({
  type: UPDATE_ADMIN_INVOICE_RESULT,
  result
})
export const updateAdminInvoiceResultFailed = () => ({
  type: UPDATE_ADMIN_INVOICE_RESULT_FAILED
})
export const adminSendNewInvoiceSuccess = () => ({
  type: ADMIN_SEND_NEW_INVOICE_SUCCESS
})
export const adminGeneratePDFSuccess = () => ({
  type: ADMIN_GENERATE_PDF_SUCCESS
})
export const adminGeneratePDFFailed = (result) => ({
  type: ADMIN_GENERATE_PDF_FAILED,
  result
})
export const showLatestInvoicePDF = (Id, uuid, base_invoice_id, base_uuid) => ({
  type: SHOW_LATEST_INVOICE_PDF,
  Id,
  uuid,
  base_invoice_id,
  base_uuid
})
export const hideAdminSnackbar = () => ({ type: HIDE_ADMIN_SNACKBAR })
export const searchAdminWages = (selectedPage, refreshSearch, formValues) => ({
  type: SEARCH_ADMIN_WAGES,
  selectedPage,
  refreshSearch,
  formValues
})
export const adminsearchIRSalaryInfo = (formValues) => ({
  type: SEARCH_ADMIN_IR,
  formValues
})
export const updateAdminInvoiceStatus = (invoice_id) => ({
  type: UPDATE_ADMIN_INVOICE_STATUS,
  invoice_id
})
export const updateAdminSalaryStatus = (id) => ({
  type: UPDATE_ADMIN_SALARY_STATUS,
  id
})
export const irSearchPageChange = (selected) => ({
  type: IR_SEARCH_PAGE_CHANGE,
  selected
})
export const userSearchPageChange = (selected) => ({
  type: USER_SEARCH_PAGE_CHANGE,
  selected
})
export const tiedotteetSearchPageChange = (selected) => ({
  type: TIEDOTTEET_SEARCH_PAGE_CHANGE,
  selected
})
export const releaseInfoSearchPageChange = (selected) => ({
  type: RELEASE_INFO_SEARCH_PAGE_CHANGE,
  selected
})
export const warnInvoiceToPay = (selected) => ({
  type: WARN_INVOICE_TO_PAY,
  selected
})
export const warnSalaryToPay = (selected) => ({
  type: WARN_SALARY_TO_PAY,
  selected
})
export const confirmSalaryToPay = () => ({ type: CONFIRM_SALARY_TO_PAY })
export const importKassavirtanenSalaries = (selected) => ({
  type: IMPORT_KASSAVIRTANEN_SALARIES,
  selected
})
export const salarySendtoIR = (selected) => ({
  type: SALARY_SEND_TO_IR,
  selected
})
export const cancelSalaryIRReport = (selected) => ({
  type: CANCEL_SALARY_IR_REPORT,
  selected
})
export const updateSalaryStatusIR = (selected) => ({
  type: UPDATE_ADMIN_SALARY_STATUS_IR,
  selected
})
export const manualPaySalaries = (selected) => ({
  type: MANUAL_PAY_SALARIES,
  selected
})
export const cancelUpdateAdminInvoiceStatus = () => ({
  type: CANCEL_UPDATE_ADMIN_INVOICE_STATUS
})
export const closeDialog = () => ({
  type: CLOSE_DIALOG
})
export const cancelUpdateAdminSalaryStatus = (id) => ({
  type: CANCEL_UPDATE_ADMIN_SALARY_STATUS,
  id
})
export const removePaymentDialog = () => ({
  type: REMOVE_PAYMENT_DIALOG
})
export const cancelUpdateAdminSalaryStatusSuccess = () => ({
  type: CANCEL_UPDATE_ADMIN_SALARY_STATUS_SUCCESS
})
export const addSalarySuccess = () => ({ type: ADD_SALARY_SUCCESS })
export const addSalaryFailure = () => ({ type: ADD_SALARY_FAILURE })
export const closeSalaryPayError = () => ({ type: CLOSE_SALARY_PAY_ERROR })
export const warnToAddCost = () => ({ type: WARN_TO_ADD_COST })
export const updateAdminInvoiceStatusSuccess = () => ({
  type: UPDATE_ADMIN_INVOICE_STATUS_SUCCESS
})
export const updateAdminSalaryStatusSuccess = (result) => ({
  type: UPDATE_ADMIN_SALARY_STATUS_SUCCESS,
  result
})
export const updateAdminSalaryStatusFailed = () => ({
  type: UPDATE_ADMIN_SALARY_STATUS_FAILED
})
export const updateAdminBankPaymentSuccess = () => ({
  type: UPDATE_ADMIN_BANK_PAYMENT_SUCCESS
})
export const updateAdminBankPaymentFailed = (result) => ({
  type: UPDATE_ADMIN_BANK_PAYMENT_FAILED,
  result
})
export const updateAdminIRFailed = (result) => ({
  type: UPDATE_ADMIN_IR_FAILED,
  result
})

export const getAdminExpenseReportSuccess = (result) => ({
  type: GET_ADMIN_EXPENSE_REPORT_SUCCESS,
  result
})
export const getAdminExpenseReportFailed = (result) => ({
  type: GET_ADMIN_EXPENSE_REPORT_FAILED,
  result
})

export const adminAddNewUpdates = (formValues) => ({
  type: ADMIN_ADD_NEW_UPDATES,
  formValues
})
export const adminAddNewUpdatesSuccess = (formValues) => ({
  type: ADMIN_ADD_NEW_UPDATES_SUCCESS,
  formValues
})
export const adminDeleteCompanyUpdates = (id) => ({
  type: ADMIN_DELETE_COMPANY_UPDATE,
  id
})
export const adminDeleteCompanyUpdatesSuccess = () => ({
  type: ADMIN_DELETE_COMPANY_UPDATE_SUCCESS
})
export const adminGetUpdates = () => ({ type: ADMIN_GET_UPDATES })
export const adminGetUpdatesSuccess = (result) => ({
  type: ADMIN_GET_UPDATES_SUCCESS,
  result
})
export const noPikapalkka = (payload) => ({ type: NO_PIKAPALKKA, payload })
export const showSalaryPDF = (salary_id, uuid, invoice_uuid) => ({
  type: SHOW_SALARY_PDF,
  salary_id,
  uuid,
  invoice_uuid
})
export const showInvoicePDF = (invoice_id) => ({
  type: SHOW_INVOICE_PDF,
  invoice_id
})
export const showReminderInvoicePDF = (invoice_id) => ({
  type: SHOW_REMINDER_INVOICE_PDF,
  invoice_id
})
export const getAdminExpenseReport = (formValues) => ({
  type: GET_ADMIN_EXPENSE_REPORT,
  formValues
})
export const updateAdminInvoiceStatusToRejected = () => ({
  type: UPDATE_ADMIN_INVOICE_STATUS_REJECTED
})
export const updateAdminInvoiceStatusToNew = (status, notes) => ({
  type: UPDATE_ADMIN_INVOICE_STATUS_NEW,
  status,
  notes
})

export const updateAdminInvoiceStatusToLoaned = () => ({
  type: UPDATE_ADMIN_INVOICE_STATUS_LOANED
})
export const updateAdminInvoiceStatusToNotAccepted = () => ({
  type: UPDATE_ADMIN_INVOICE_STATUS_NOT_ACCEPTED
})
export const updateAdminInvoiceStatusToPaidAndNewInvoice = () => ({
  type: UPDATE_ADMIN_INVOICE_STATUS_PAID_AND_NEW_INVOICE
})
export const sentInvoiceReminder = (invoice_id) => ({
  type: SENT_INVOICE_REMINDER,
  invoice_id
})
export const updateAdminInvoiceStatusToPerinnassa = (invoice_id) => ({
  type: UPDATE_ADMIN_INVOICE_STATUS_PERINNASSA,
  invoice_id
})

export const updateAdminTable = () => ({
  type: UPDATE_ADMIN_TABLE
})

export const updateAdminTableSuccess = () => ({
  type: UPDATE_ADMIN_TABLE_SUCCESS
})

export const getAdminSalaryUlosottoInfo = (uuid) => ({
  type: GET_ADMIN_SALARY_ULOSOTTO_INFO,
  uuid
})

export const getAdminSalaryUlosottoInfoSuccess = (result) => ({
  type: GET_ADMIN_SALARY_ULOSOTTO_INFO_SUCCESS,
  result
})

// KAS-337 search all admin invoices rows when startdate and enddate  are searched
export const searchAdminInvoiceAllRowsSuccess = (invoices) => ({
  type: SEARCH_ADMIN_INVOICE_ALL_ROWS_SUCCESS,
  invoices
})

// PI-296 Fetching all salaries record
export const searchAdminAllSalaryRecarodsSuccess = (salaries) => ({
  type: SEARCH_ADMIN_SALARY_ALL_RECORDS_SUCCESS,
  salaries
})

// KAS-344 update industry tax card at Admin
export const adminUpdateIndustryTaxCardSuccess = (data) => ({
  type: ADMIN_UPDATE_INDUSTRY_TAX_CARD_SUCCESS,
  data
})
export const adminUpdateIndustryTaxCardFailed = (error) => ({
  type: ADMIN_UPDATE_INDUSTRY_TAX_CARD_FAILED,
  error
})

export const searchCompanyCustomers = (email) => ({
  type: SEARCH_COMPANY_CUSTOMERS,
  email
})

export const searchCompanyInvoices = (email) => ({
  type: SEARCH_COMPANY_INVOICES,
  email
})

export const searchCompanySalaries = (email) => {
  return {
    type: SEARCH_COMPANY_SALARIES,
    email
  }
}

export const getNewSalaryStart = (data) => ({
  type: GET_NEW_SALARY_START,
  data
})
export const getNewSalarySuccess = (result) => ({
  type: GET_NEW_SALARY_SUCCESS,
  result
})
export const getSalariesStart = (data) => ({ type: GET_SALARIES_START, data })
export const getSalariesSuccess = (resultParsed) => ({
  type: GET_SALARIES_SUCCESS,
  resultParsed
})
export const selectRowSalary = (selected) => ({
  type: SELECT_ROW_SALARY,
  selected
})
export const selectRowSalarySuccess = (result) => ({
  type: SELECT_ROW_SALARY_SUCCESS,
  result
})
export const clearSalarySelection = () => ({ type: CLEAR_SALARY_SELECTION })
export const postSalary = (selected) => ({ type: POST_SALARY, selected })
export const getSalaryInfo = (id) => ({ type: GET_SALARY_INFO, id })
export const getSalaryByIdSuccess = (result) => ({
  type: GET_SALARY_BY_ID_SUCCESS,
  result
})
export const salaryPageChange = (selected) => ({
  type: SALARY_PAGE_CHANGE,
  selected
})
export const saveSalarySlip = (id, invoice_uuid) => ({
  type: SAVE_SALARY_SLIP,
  id,
  invoice_uuid
})
export const cancelPaySalary = () => ({ type: CANCEL_PAY_SALARY })
export const handleChangeLang = (lang) => ({ type: LANGUAGE_CHANGE, lang })
export const warnNoSSN = () => ({ type: WARN_NO_SSN })

// TOKEN REFESH
export const refreshToken = () => ({ type: REFRESH_TOKEN })
export const validateToken = (isUserActive) => ({
  type: VALIDATE_TOKEN,
  isUserActive
})
export const refreshTokenSuccess = () => ({ type: REFRESH_TOKEN_SUCCESS })

export const addExpensesToInvoice = (expenses, formValues, invoiceEdit) => ({
  type: ADD_EXPENSES_TO_INVOICE,
  expenses,
  formValues,
  invoiceEdit
})
export const updateInvoiceIdToExpense = (invoice_id, option, selected) => ({
  type: UPDATE_INVOICEID_TO_EXPENSE,
  invoice_id,
  option,
  selected
})
export const updateInvoiceIdToAllowance = (invoice_id, option, selected) => ({
  type: UPDATE_INVOICEID_TO_ALLOWANCE,
  invoice_id,
  option,
  selected
})
export const addAllowancesToInvoice = (
  allowances,
  formValues,
  invoiceEdit
) => ({
  type: ADD_ALLOWANCES_TO_INVOICE,
  allowances,
  formValues,
  invoiceEdit
})

export const showExpenseDialog = (selected) => ({
  type: SHOW_EXPENSE_DIALOG,
  selected
})
export const cancelExpenseDialog = () => ({ type: CANCEL_EXPENSE_DIALOG })
export const showAllowanceDialog = (selected) => ({
  type: SHOW_ALLOWANCE_DIALOG,
  selected
})
export const cancelAllowanceDialog = () => ({ type: CANCEL_ALLOWANCE_DIALOG })
export const cancelInvoiceInfoDialog = () => ({
  type: CANCEL_INVOICE_INFO_DIALOG
})

export const enableExpenseBackBtn = (formValues) => ({
  type: ENABLE_EXPENSE_BACK_BTN,
  formValues
})
export const enableAllowanceBackBtn = (formValues) => ({
  type: ENABLE_ALLOWANCE_BACK_BTN,
  formValues
})
export const disableExpenseBackBtn = () => ({ type: DISABLE_EXPENSE_BACK_BTN })
export const disableAllowanceBackBtn = () => ({
  type: DISABLE_ALLOWANCE_BACK_BTN
})

export const loadInvoiceItems = () => ({ type: LOAD_INVOICE_ITEMS })
export const closeLoadInvoiceItems = () => ({ type: CLOSE_LOAD_INVOICE_ITEMS })

export const loadExpenseItems = () => ({ type: LOAD_EXPENSE_ITEMS })
export const closeLoadExpenseItems = () => ({ type: CLOSE_LOAD_EXPENSE_ITEMS })

export const loadSalaryItems = () => ({ type: LOAD_SALARY_ITEMS })
export const closeLoadSalaryItems = () => ({ type: CLOSE_LOAD_SALARY_ITEMS })

// ADMIN USER
export const getAdminUsersList = () => ({ type: GET_ADMIN_USERS_LIST })
export const getAdminUsersListSuccess = (result) => ({
  type: GET_ADMIN_USERS_LIST_SUCCESS,
  result
})
export const getAdminUsersListFail = () => ({ type: GET_ADMIN_USERS_LIST_FAIL })

export const selectUser = (data) => ({ type: SELECT_USER, data })
export const selectUserSuccess = (data) => ({ type: SELECT_USER_SUCCESS, data })
export const unselectUser = () => ({ type: UNSELECT_USER })

export const getUserInfo = (data) => ({ type: GET_USER_INFO, data })
export const getUserInfoSuccess = (data) => ({
  type: GET_USER_INFO_SUCCESS,
  data
})

export const clearSelectedUser = () => ({ type: CLEAR_SELECTED_USER })
export const priceChange = (price) => ({ type: PRICE_CHANGE, price })
export const getCountryList = () => ({ type: GET_COUNTRY_LIST })
export const getCountryListSuccess = (data) => ({
  type: GET_COUNTRY_LIST_SUCCESS,
  data
})

export const getFieldOfWork = () => ({ type: GET_FIELD_OF_WORK })
export const getFieldOfWorkSuccess = (data) => ({
  type: GET_FIELD_OF_WORK_SUCCESS,
  data
})

export const loadOpenForWorkStart = () => ({
  type: LOAD_OPEN_FOR_WORK_START
})
export const loadOpenForWorkSuccess = (result) => ({
  type: LOAD_OPEN_FOR_WORK_SUCCESS,
  result
})
export const loadOpenForWorkFailed = (error) => ({
  type: LOAD_OPEN_FOR_WORK_FAILED,
  error
})
export const updateOpenForWork = (formValues, files) => ({
  type: UPDATE_OPEN_FOR_WORK,
  formValues,
  files
})
export const updateOpenForWorkSuccess = (result) => ({
  type: UPDATE_OPEN_FOR_WORK_SUCCESS,
  result
})
export const updateOpenForWorkFailed = (error) => ({
  type: UPDATE_OPEN_FOR_WORK_FAILED,
  error
})

export const closeOpenForWorkSnackBar = () => ({
  type: CLOSE_OPEN_FOR_WORK_SNACKBAR
})
export const getAreaOfExpertise = () => ({ type: GET_AREA_OF_EXPERTISE })
export const getAreaOfExpertiseSuccess = (data) => ({
  type: GET_AREA_OF_EXPERTISE_SUCCESS,
  data
})
export const getAreaOfWork = () => ({ type: GET_AREA_OF_WORK })
export const getAreaOfWorkSuccess = (data) => ({
  type: GET_AREA_OF_WORK_SUCCESS,
  data
})
export const notOpenForWork = () => ({
  type: NOT_OPEN_FOR_WORK
})
export const notOpenForWorkSuccess = (data) => ({
  type: NOT_OPEN_FOR_WORK_SUCCESS,
  data
})
export const notOpenForWorkFailed = (error) => ({
  type: NOT_OPEN_FOR_WORK_FAILED,
  error
})
export const getAllAssignments = () => ({
  type: GET_ALL_ASSIGNMENTS
})
export const getAllAssignmentsSuccess = (data) => ({
  type: GET_ALL_ASSIGNMENTS_SUCCESS,
  data
})
export const getAllAssignmentsFailed = (error) => ({
  type: GET_ALL_ASSIGNMENTS_FAILED,
  error
})
export const updateViewAssignment = (assignment_id, uuid) => ({
  type: UPDATE_VIEW_ASSIGNMENT,
  assignment_id,
  uuid
})
export const pinAssignment = (assignment_id) => ({
  type: PIN_ASSIGNMENT,
  assignment_id
})
export const pinAssignmentSuccess = (data) => ({
  type: PIN_ASSIGNMENT_SUCCESS,
  data
})
export const pinAssignmentFailed = (error) => ({
  type: PIN_ASSIGNMENT_FAILED,
  error
})
export const applicationListPageChange = (selected) => ({
  type: APPLICATION_LIST_PAGE_CHANGE,
  selected
})
export const setTotalAssignments = (data) => ({
  type: SET_TOTAL_ASSIGNMENTS,
  data
})
export const setTotalApplications = (data) => ({
  type: SET_TOTAL_APPLICATIONS,
  data
})
export const setTotalWorkshifts = (data) => ({
  type: SET_TOTAL_WORKSHIFTS,
  data
})
export const applyAssignment = (job) => ({
  type: APPLY_ASSIGNMENT,
  job
})
export const cancelApplyAssignment = () => ({
  type: CANCEL_APPLY_ASSIGNMENT
})
export const searchAssignment = (values) => ({
  type: SEARCH_ASSIGNMENT,
  values
})
export const searchAssignmentSuccess = (data, pageSize, formValues) => ({
  type: SEARCH_ASSIGNMENT_SUCCESS,
  data,
  pageSize,
  formValues
})
export const searchAssignmentFailed = (error) => ({
  type: SEARCH_ASSIGNMENT_FAILED,
  error
})
export const sendApplication = (job_info, ratingData) => ({
  type: SEND_APPLICATION,
  job_info,
  ratingData
})
export const sendApplicationSuccess = (data) => ({
  type: SEND_APPLICATION_SUCCESS,
  data
})
export const sendApplicationFailed = (error) => ({
  type: SEND_APPLICATION_FAILED,
  error
})
export const closeSuccessSendApplication = () => ({
  type: CLOSE_SUCCESS_SEND_APPLICATION
})
export const seeMyApplication = () => ({
  type: SEE_MY_APPLICATION
})
export const getAssignmentOfferToEmail = () => ({
  type: GET_ASSIGNMENT_OFFERED_TO_EMAIL
})
export const getAssignmentOfferToEmailSuccess = (data) => ({
  type: GET_ASSIGNMENT_OFFERED_TO_EMAIL_SUCCESS,
  data
})
export const getAssignmentOfferToEmailFailed = (error) => ({
  type: GET_ASSIGNMENT_OFFERED_TO_EMAIL_FAILED,
  error
})
export const trackApplication = () => ({
  type: TRACK_APPLICATION
})
export const trackApplicationSuccess = (data) => ({
  type: TRACK_APPLICATION_SUCCESS,
  data
})
export const trackApplicationFailed = (error) => ({
  type: TRACK_APPLICATION_FAILED,
  error
})
export const workshiftPageChange = (selected) => ({
  type: WORKSHIFT_PAGE_CHANGE,
  selected
})
export const getWorkshiftUser = () => ({
  type: GET_WORKSHIFT_USER
})
export const getWorkshiftUserSuccess = (data) => ({
  type: GET_WORKSHIFT_USER_SUCCESS,
  data
})
export const getWorkshiftUserFailed = (error) => ({
  type: GET_WORKSHIFT_USER_FAILED,
  error
})
export const getBillableHourUser = () => ({
  type: GET_BILLABLE_HOUR_USER
})
export const getBillableHourUserSuccess = (data) => ({
  type: GET_BILLABLE_HOUR_USER_SUCCESS,
  data
})
export const getBillableHourUserFailed = (error) => ({
  type: GET_BILLABLE_HOUR_USER_FAILED,
  error
})
export const updateUserWorkshift = (values, status) => ({
  type: UPDATE_USER_WORKSHIFT,
  values,
  status
})
export const updateUserWorkshiftSuccess = (data) => ({
  type: UPDATE_USER_WORKSHIFT_SUCCESS,
  data
})
export const updateUserWorkshiftFailed = (error) => ({
  type: UPDATE_USER_WORKSHIFT_FAILED,
  error
})
export const requestEditActualHour = (values, data) => ({
  type: REQUEST_EDIT_ACTUAL_HOUR,
  values,
  data
})
export const requestEditActualHourSuccess = (data) => ({
  type: REQUEST_EDIT_ACTUAL_HOUR_SUCCESS,
  data
})
export const requestEditActualHourFailed = (error) => ({
  type: REQUEST_EDIT_ACTUAL_HOUR_FAILED,
  error
})
export const workshiftByEmployer = (company) => ({
  type: WORKSHIFT_BY_EMPLOYER,
  company
})
export const getEmployerWorkshift = () => ({
  type: GET_EMPLOYER_WORKSHIFT
})
export const getEmployerWorkshiftSuccess = (data) => ({
  type: GET_EMPLOYER_WORKSHIFT_SUCCESS,
  data
})
export const getEmployerWorkshiftFailed = (error) => ({
  type: GET_EMPLOYER_WORKSHIFT_FAILED,
  error
})
export const getJournal = () => ({
  type: GET_JOURNAL
})
export const getJournalSuccess = (data) => ({
  type: GET_JOURNAL_SUCCESS,
  data
})
export const getJournalFailed = (error) => ({
  type: GET_JOURNAL_FAILED,
  error
})
export const addJournalDetail = (formValues) => ({
  type: ADD_JOURNAL_DETAIL,
  formValues
})
export const addJournalDetailSuccess = (data) => ({
  type: ADD_JOURNAL_DETAIL_SUCCESS,
  data
})
export const addJournalDetailFailed = (error) => ({
  type: ADD_JOURNAL_DETAIL_FAILED,
  error
})
export const getJournalEdit = (id) => ({
  type: GET_JOURNAL_EDIT,
  id
})
export const getJournalEditSuccess = (data) => ({
  type: GET_JOURNAL_EDIT_SUCCESS,
  data
})
export const getJournalEditFailed = (error) => ({
  type: GET_JOURNAL_EDIT_FAILED,
  error
})
export const cancelJournalEdit = () => ({
  type: CANCEL_JOURNAL_EDIT
})
export const deleteJournal = (id) => ({
  type: DELETE_JOURNAL,
  id
})
export const deleteJournalSuccess = (data) => ({
  type: DELETE_JOURNAL_SUCCESS,
  data
})
export const deleteJournalFailed = (error) => ({
  type: DELETE_JOURNAL_FAILED,
  error
})
export const warnDeleteJournal = (id) => ({
  type: WARN_DELETE_JOURNAL,
  id
})
export const closeWarnDeleteJournal = () => ({
  type: CLOSE_WARN_DELETE_JOURNAL
})
export const closeUserWorkshiftSnackbar = () => ({
  type: CLOSE_USER_WORKSHIFT_SNACKBAR
})
export const updateJournalDetail = (formValues) => ({
  type: UPDATE_JOURNAL_DETAIL,
  formValues
})
export const updateJournalDetailSuccess = (data) => ({
  type: UPDATE_JOURNAL_DETAIL_SUCCESS,
  data
})
export const updateJournalDetailFailed = (error) => ({
  type: UPDATE_JOURNAL_DETAIL_FAILED,
  error
})
export const updateViewWorkshift = (workshift_itemid) => ({
  type: UPDATE_VIEW_WORKSHIFT,
  workshift_itemid
})
export const pinWorkShift = (id) => ({
  type: PIN_WORKSHIFT,
  id
})
export const pinWorkShiftSuccess = (data) => ({
  type: PIN_WORKSHIFT_SUCCESS,
  data
})
export const pinWorkShiftFailed = (error) => ({
  type: PIN_WORKSHIFT_FAILED,
  error
})
export const openSignBox = (assignmentData) => ({
  type: OPEN_SIGN_BOX,
  assignmentData
})
export const cancelOpenSignBox = () => ({
  type: CANCEL_OPEN_SIGN_BOX
})
export const rejectAssignment = (reason, data) => ({
  type: REJECT_ASSIGNMENT,
  reason,
  data
})
export const rejectAssignmentSuccess = (data) => ({
  type: REJECT_ASSIGNMENT_SUCCESS,
  data
})
export const askBeforeRejectAssignment = (assignmentData) => ({
  type: ASK_BEFORE_REJECT_ASSIGNMENT,
  assignmentData
})
export const cancelRejectAssignment = () => ({
  type: CANCEL_REJECT_ASSIGNMENT
})
export const getApplicationProfile = (values) => ({
  type: GET_APPLICATION_PROFILE,
  values
})
export const getApplicationProfileSuccess = (data) => ({
  type: GET_APPLICATION_PROFILE_SUCCESS,
  data
})
export const getApplicationProfileFailed = (error) => ({
  type: GET_APPLICATION_PROFILE_FAILED,
  error
})
export const closeApplicationProfile = () => ({
  type: CLOSE_APPLICATION_PROFILE
})
export const signAndSendAssignment = (offerData, trim, draftInvoiceValues) => ({
  type: SIGN_AND_SEND_ASSIGNMENT,
  offerData,
  trim,
  draftInvoiceValues
})
export const signAndSendAssignmentSuccess = (data) => ({
  type: SIGN_AND_SEND_ASSIGNMENT_SUCCESS,
  data
})
export const signAndSendAssignmentFailed = (error) => ({
  type: SIGN_AND_SEND_ASSIGNMENT_FAILED,
  error
})
export const closeApplicationSnackbar = () => ({
  type: CLOSE_APPLICATION_SNACKBAR
})
export const loadSignSend = () => ({
  type: LOAD_SIGN_SEND
})
export const closeLoadSignSend = () => ({
  type: CLOSE_LOAD_SIGN_SEND
})
export const updateViewApplication = (agreement_id) => ({
  type: UPDATE_VIEW_APPLICATION,
  agreement_id
})
export const pinApplication = (agreement_id) => ({
  type: PIN_APPLICATION,
  agreement_id
})
export const pinApplicationSuccess = (data) => ({
  type: PIN_APPLICATION_SUCCESS,
  data
})
export const pinApplicationFailed = (error) => ({
  type: PIN_APPLICATION_FAILED,
  error
})
// KAS-335 construction/shipbuilding industry tax card actions

export const shipbuildingTaxCard = (formValues) => ({
  type: SHIPBUILDING_INDUSTRY_TAX_CARD,
  formValues
})
export const shipbuildingTaxCardSuccess = (result) => ({
  type: SHIPBUILDING_INDUSTRY_TAX_CARD_SUCCESS,
  result
})
export const shipbuildingTaxCardFailed = () => ({
  type: SHIPBUILDING_INDUSTRY_TAX_CARD_FAILED
})

export const getIndustryTaxCard = (userData) => ({
  type: GET_INDUSTRY_TAX_CARD,
  userData
})
export const getIndustryTaxCardSuccess = (data) => ({
  type: GET_INDUSTRY_TAX_CARD_SUCCESS,
  data
})
export const getIndustryTaxCardFailed = () => ({
  type: GET_INDUSTRY_TAX_CARD_FAILED
})

export const generateIndustryTaxPDFSuccess = (data) => ({
  type: GENERATE_INDUSTRY_TAX_PDF_SUCCESS,
  data
})
export const generateIndustryTaxPDFFailed = () => ({
  type: GENERATE_INDUSTRY_TAX_PDF_FAILED
})

export const goToReminder = (formValues) => ({
  type: GO_TO_RIMINDER,
  formValues
})
export const closeSnackbar = () => ({
  type: CLOSE_SNACKBAR
})

// KAS-356 Refresh page after click out of last chance send referral code form
export const handleRefreshClick = () => {
  window.location.reload()
}

export const setAddingLogo = (addingLogo) => ({
  type: SET_ADDING_LOGO,
  addingLogo
})
export const saveLogo = (file) => ({ type: SAVE_LOGO, file })
export const saveLogoSuccess = (data) => ({ type: SAVE_LOGO_SUCCESS, data })
export const saveLogoFailed = () => ({ type: SAVE_LOGO_FAILED })
export const getLogo = (data) => ({ type: GET_LOGO, data })
export const getLogoSuccess = (logo) => ({ type: GET_LOGO_SUCCESS, logo })
export const deleteLogo = () => ({ type: DELETE_LOGO })
export const deleteLogoSuccess = () => ({ type: DELETE_LOGO_SUCCESS })
export const deleteLogoFailed = () => ({ type: DELETE_LOGO_FAILED })
export const invalidLogo = (error) => ({ type: INVALID_LOGO, error })
export const closeLogoSnackbar = () => ({ type: CLOSE_LOGO_SNACKBAR })

export const changeRowsPerPage = (rows) => ({
  type: CHANGE_ROWS_PER_PAGE,
  rows
})

export const expandAdminSalary = (expanded, id, index) => ({
  type: EXPAND_ADMIN_SALARY,
  expanded,
  id,
  index
})

export const expandAdminSalaryTrue = (result) => ({
  type: EXPAND_ADMIN_SALARY_TRUE,
  result
})

export const expandAdminSalaryFalse = (id) => ({
  type: EXPAND_ADMIN_SALARY_FALSE,
  id
})

export const updateAdminSalary = (formValues) => ({
  type: UPDATE_ADMIN_SALARY,
  formValues
})

export const closeAdminSalaryForms = () => ({
  type: CLOSE_ADMIN_SALARY_FORMS
})

export const closeAdminSalaryFormsSuccess = () => ({
  type: CLOSE_ADMIN_SALARY_FORMS_SUCCESS
})

export const getRegisteredUsersList = (email) => ({
  type: GET_REGISTERED_USERS_LIST,
  email
})

export const getRegisteredUsersListSuccess = (data) => ({
  type: GET_REGISTERED_USERS_LIST_SUCCESS,
  data
})

export const getRegisteredUsersListFailed = (error) => ({
  type: GET_REGISTERED_USERS_LIST_FAILED,
  error
})

export const getInvoiceUserEmail = (i, data) => ({
  type: GET_INVOICE_USER_EMAIL,
  i,
  data
})

export const openCompanyNotificationDialog = () => ({
  type: OPEN_COMPANY_NOTIFICATION_DIALOG
})
export const closeCompanyNotificationDialog = () => ({
  type: CLOSE_COMPANY_NOTIFICATION_DIALOG
})

export const removeInvoiceFeeWithReason = (feeType) => ({
  type: REMOVE_INVOICE_FEE_WITH_REASON,
  feeType
})

export const cancelRemoveInvoiceFeeDialog = () => ({
  type: CANCEL_REMOVE_INVOICE_FEE_DIALOG
})

export const downloadCustomersReport = (values) => ({
  type: DOWNLOAD_CUSTOMERS_REPORT,
  values
})

export const setCustomerFormReadOnly = (isReadOnly) => ({
  type: SET_CUSTOMER_FORM_READONLY,
  payload: isReadOnly
})

export const copyAllowance = (id) => ({
  type: COPY_ALLOWANCE,
  id
})

export const updateUserEmail = (values) => ({
  type: UPDATE_USER_EMAIL,
  values
})
export const updateUserEmailSuccess = (data) => ({
  type: UPDATE_USER_EMAIL_SUCCESS,
  data
})
export const updateUserEmailFailed = (error) => ({
  type: UPDATE_USER_EMAIL_FAILED,
  error
})

export const verifyUserProfile = () => ({ type: VERIFY_USER_PROFILE })

export const showInvoiceFormDialog = () => ({
  type: SHOW_INVOICE_FORM_DIALOG
})

export const closeInvoiceFormDialog = () => ({
  type: CLOSE_INVOICE_FORM_DIALOG
})

export const resetInvoices = () => ({
  type: RESET_INVOICES
})

export const clearInvoiceEditValues = () => ({
  type: CLEAR_INVOICE_EDIT_VALUES
})
